import { Checkbox } from '@chakra-ui/react'
import { iPermissaoFuncionalidade, useAuth } from '../../../../../contexts/AuthContext'
import { blackList, PermissoesOrdenadas, renomearFuncionalidades } from '../permissoesHelper'
import { Container } from './styles'

const modulosSoGestor = ['PRISMAH', 'CargosESalarios']

interface TabelaProps {
  permissao: iPermissaoFuncionalidade[]
}

export const TabelaPermissoes: React.FC<TabelaProps> = ({ permissao }) => {
  const { Atualizar } = useAuth()

  function TemPermissao(tipo: number, funcionaliade: string): boolean {
    return permissao.find(e => e.tipoUsuario === tipo && e.funcionalidade === funcionaliade)?.permitir as boolean
  }

  return (
    <Container>
      <thead>
        <tr>
          <th style={{ textAlign: 'start' }}>Funcionalidade</th>
          <th>Colaborador</th>
          <th>Gestor</th>
        </tr>
      </thead>
      <tbody>
        {
          PermissoesOrdenadas(permissao).map((e, i) => {
            return (
              <tr key={i}>
                <td style={{ textAlign: 'start' }}>
                  {renomearFuncionalidades(e.funcionalidade)}
                </td>
                <td>
                  <div className='tdCenter'>
                    {!blackList?.some(r => r === e.funcionalidade) && !modulosSoGestor.includes(e.modulo) &&
                      <Checkbox
                        onChange={(c) => Atualizar(e.modulo, e.funcionalidade, c.target.checked, 0)}
                        isDisabled={e.tipoUsuario === 0 && e.funcionalidade.toLowerCase().includes('dash')}
                        isChecked={TemPermissao(0, e.funcionalidade)}
                        borderColor={'var(--Gray4)'}
                      />}
                  </div>
                </td>
                <td>
                  <div className='tdCenter'>
                    <Checkbox onChange={(c) => Atualizar(e.modulo, e.funcionalidade, c.target.checked, 1)}
                      isChecked={TemPermissao(1, e.funcionalidade)}
                      borderColor={'var(--Gray4)'}
                    />
                  </div>
                </td>
              </tr>
            )
          })
        }
      </tbody>
    </Container>
  )
}
